import { motion } from 'framer-motion';
import PageLayout from '@/components/layout/PageLayout';

const CookiePolicyPage = () => {
  return (
    <PageLayout>
      <section className="pb-24 pt-8" data-testid="cookie-policy-page">
        <div className="max-w-3xl mx-auto px-6">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <h1 className="font-heading text-4xl sm:text-5xl font-bold text-taxera-charcoal mb-4">
              Cookie Policy
            </h1>
            <p className="text-slate-500 mb-12">Last updated: February 2026</p>

            <div className="prose prose-slate max-w-none space-y-8">
              <section>
                <h2 className="font-heading text-2xl font-bold text-taxera-charcoal">What Are Cookies</h2>
                <p className="text-slate-600 leading-relaxed">
                  Cookies are small text files stored on your device when you visit a website. They help us improve your experience by remembering your preferences and understanding how you interact with our website.
                </p>
              </section>

              <section>
                <h2 className="font-heading text-2xl font-bold text-taxera-charcoal">Cookies We Use</h2>

                <div className="space-y-6 mt-4">
                  <div className="bg-slate-50 rounded-xl p-6 border border-slate-200">
                    <h3 className="font-heading text-lg font-bold text-taxera-charcoal mb-2">Strictly Necessary</h3>
                    <p className="text-slate-600 text-sm mb-3">Required for the website to function. Cannot be disabled.</p>
                    <div className="overflow-x-auto">
                      <table className="w-full text-sm">
                        <thead>
                          <tr className="border-b border-slate-200">
                            <th className="text-left py-2 text-slate-500 font-medium">Cookie</th>
                            <th className="text-left py-2 text-slate-500 font-medium">Purpose</th>
                            <th className="text-left py-2 text-slate-500 font-medium">Duration</th>
                          </tr>
                        </thead>
                        <tbody className="text-slate-600">
                          <tr className="border-b border-slate-100">
                            <td className="py-2 font-mono text-xs">session_token</td>
                            <td className="py-2">User authentication</td>
                            <td className="py-2">7 days</td>
                          </tr>
                          <tr className="border-b border-slate-100">
                            <td className="py-2 font-mono text-xs">cookie_consent</td>
                            <td className="py-2">Stores your cookie preferences</td>
                            <td className="py-2">365 days</td>
                          </tr>
                          <tr>
                            <td className="py-2 font-mono text-xs">i18next</td>
                            <td className="py-2">Language preference</td>
                            <td className="py-2">365 days</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="bg-slate-50 rounded-xl p-6 border border-slate-200">
                    <h3 className="font-heading text-lg font-bold text-taxera-charcoal mb-2">Analytics</h3>
                    <p className="text-slate-600 text-sm mb-3">Help us understand how visitors interact with our website.</p>
                    <div className="overflow-x-auto">
                      <table className="w-full text-sm">
                        <thead>
                          <tr className="border-b border-slate-200">
                            <th className="text-left py-2 text-slate-500 font-medium">Cookie</th>
                            <th className="text-left py-2 text-slate-500 font-medium">Purpose</th>
                            <th className="text-left py-2 text-slate-500 font-medium">Duration</th>
                          </tr>
                        </thead>
                        <tbody className="text-slate-600">
                          <tr className="border-b border-slate-100">
                            <td className="py-2 font-mono text-xs">_ga</td>
                            <td className="py-2">Google Analytics visitor identification</td>
                            <td className="py-2">2 years</td>
                          </tr>
                          <tr>
                            <td className="py-2 font-mono text-xs">_gid</td>
                            <td className="py-2">Google Analytics session identification</td>
                            <td className="py-2">24 hours</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="bg-slate-50 rounded-xl p-6 border border-slate-200">
                    <h3 className="font-heading text-lg font-bold text-taxera-charcoal mb-2">Marketing</h3>
                    <p className="text-slate-600 text-sm mb-3">Used to deliver relevant advertisements and measure campaign effectiveness.</p>
                    <p className="text-slate-500 text-sm italic">We currently do not use marketing cookies.</p>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="font-heading text-2xl font-bold text-taxera-charcoal">Managing Your Preferences</h2>
                <p className="text-slate-600 leading-relaxed">
                  You can manage your cookie preferences at any time through the cookie consent banner or your browser settings. Note that disabling certain cookies may affect the functionality of our website.
                </p>
              </section>

              <section>
                <h2 className="font-heading text-2xl font-bold text-taxera-charcoal">Contact</h2>
                <p className="text-slate-600 leading-relaxed">
                  For questions about our use of cookies, please contact:
                </p>
                <p className="text-slate-600">
                  <a href="mailto:privacy@taxera.tech" className="text-taxera-blue hover:underline">privacy@taxera.tech</a>
                </p>
              </section>
            </div>
          </motion.div>
        </div>
      </section>
    </PageLayout>
  );
};

export default CookiePolicyPage;
